<template>
  <div class="form-group" :class="classes">
    <label :for="id" v-if="label">
      {{ label }}
      <span class="required" v-if="rules.includes('required')">*</span>
    </label>
    <Field
      :type="type"
      :name="name"
      :placeholder="placeholder"
      v-model="value"
      :disabled="disabled"
      :id="id"
      :class="inputClass"
      :maxlength="maxlength"
      @input="updatedValue"
      :rules="rules"
    />
    <ErrorMessage :name="name" class="error-message" />
  </div>
</template>
<script>
import { Field, ErrorMessage } from "vee-validate";

export default {
  components: {
    Field,
    ErrorMessage,
  },
  props: {
    maxlength: {
      type: String,
      default: () => "",
    },
    label: {
      type: String,
      default: () => null,
    },
    rules: {
      type: String,
      default: () => "",
    },
    value: {
      type: String,
      default: () => "",
    },
    name: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    classes: {
      type: String,
      default: () => "col-6",
    },
    type: {
      type: String,
      default: () => "text",
    },
    id: {
      type: String,
      default: () => "",
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    inputClass: {
      type: String,
      default: () => "",
    },
  },
  methods: {
    updatedValue(event) {
      this.$emit("updated-value", {
        name: this.name,
        value: event.target.value,
      });
    },
  },
};
</script>
